export const PRACTICE_ORIGIN = 'https://app.liontheory.com';
export function supportedPracticeLevel(level) {
  const value = String(level ?? '').trim();
  const match = value.match(/^(?:Level\s+)?([1-9])$/i);
  return match ? match[1] : null;
}
export function practiceLink(placement, { kind = 'demo', level } = {}) {
  if (kind === 'plans') return 'https://www.liontheory.com/#pricing';
  const url = new URL(kind === 'signup' ? '/signup' : kind === 'login' ? '/login' : '/demo', PRACTICE_ORIGIN);
  if (kind === 'signup') { url.searchParams.set('type', 'teacher'); url.searchParams.set('plan', 'teacher_basic'); url.searchParams.set('state', 'FL'); }
  url.searchParams.set('utm_source', 'fsmta_exams');
  url.searchParams.set('utm_medium', 'referral');
  url.searchParams.set('utm_campaign', 'florida_exam_preparation');
  url.searchParams.set('utm_content', placement);
  return url.toString();
}
export function parentPracticeMessage(level) {
  return `Optional exam preparation: Lion Theory offers Florida theory and ear-training practice. Explore the available material here: ${practiceLink('parent_share', { level })}\nPractice is separate from exam registration and is not required to take the exam.`;
}
